import { ColorV2 } from "config/colors";
import { PersonDetailTagTone } from "../../models/personView.types";

export const getTagIconColor = (tone: PersonDetailTagTone): ColorV2 => {
  if (tone === "danger") return ColorV2.NegativeRed;
  if (tone === "warning") return ColorV2.DarkAmbigiousYellow;
  if (tone === "info") return ColorV2.ElectricBlue;
  if (tone === "purple") return ColorV2.AbsentPurple;
  return ColorV2.PositiveGreen;
};
